import React from 'react'

interface Props {
               
}

 const TwitterSocial = (props: Props) => {
               return (
                   <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                       <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" fill="white" />
                       <g clipPath="url(#clip0)">
                           <path
                               d="M36 16.5585C35.1075 16.95 34.1565 17.2095 33.165 17.3355C34.185 16.7265 34.9635 15.7695 35.3295 14.616C34.3785 15.183 33.3285 15.5835 32.2095 15.807C31.3065 14.8455 30.0195 14.25 28.6155 14.25C25.8915 14.25 23.6985 16.461 23.6985 19.1715C23.6985 19.5615 23.7315 19.9365 23.8125 20.2935C19.722 20.094 16.1025 18.1335 13.671 15.147C13.2465 15.8835 12.9975 16.7265 12.9975 17.634C12.9975 19.338 13.875 20.8485 15.183 21.723C14.3925 21.708 13.617 21.4785 12.96 21.117C12.96 21.132 12.96 21.1515 12.96 21.171C12.96 23.562 14.6655 25.548 16.902 26.0055C16.5015 26.115 16.065 26.1675 15.612 26.1675C15.297 26.1675 14.979 26.1495 14.6805 26.0835C15.318 28.032 17.127 29.4645 19.278 29.511C17.604 30.8205 15.4785 31.6095 13.1775 31.6095C12.774 31.6095 12.387 31.5915 12 31.542C14.1795 32.9475 16.7625 33.75 19.548 33.75C28.602 33.75 33.552 26.25 33.552 19.749C33.552 19.5315 33.5445 19.3215 33.534 19.113C34.5105 18.42 35.331 17.5545 36 16.5585Z"
                               fill="black"
                           />
                       </g>
                       <rect x="0.5" y="0.5" width="47" height="47" rx="23.5" stroke="#EFF4FB" />
                       <defs>
                           <clipPath id="clip0">
                               <rect width="24" height="24" fill="white" transform="translate(12 12)" />
                           </clipPath>
                       </defs>
                   </svg>
               );
}
export default TwitterSocial;